module.exports = __webpack_public_path__ + "img/dt_text.823c3b91.png";